// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1LMUq","disabled":"FileBtn_disabled__K74Nw","warn":"FileBtn_warn__1CkRJ","fade":"FileBtn_fade__PhnYI"};